import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import MaskedInput from "react-maskedinput";

class EditModel extends Component {
    _isMounted = false;
    state = {
        item: {},
        errors: {},
        loading: false
    };

    componentDidMount() {
        this._isMounted = true;
        //console.log('did mount');
        this.setState({ item: this.props.item });
    }    

    update = e => {
        e.preventDefault();
        this.setState({ loading: true });
        this.props
            .update(this.props.item.id, this.state.item)
            .then(response => {
                this.setState({ loading: false });
                this.props.hideUpdate();
            })
            .catch(error => {
                this.setState({ loading: false });
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };

    componentWillUnmount() {
        this._isMounted = false;
        //console.log('will mount');
    }

    render() {
        
        return (
            <div className="model-container model-center model-backdrop-show cardModalAction">
			    <button onClick={this.props.hideUpdate} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header cardmentModelHeader">
                        <img src="/images/creditCardModel.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Update card
                    </h2>
                    <div className="modal-body">
                        <div className="form-group m-form__group">
                            <label>Card number</label><br />
                            <small class="card-text pl-3 m-0">(Card number & cvc is hidden for security purpose)</small>
                            <MaskedInput
                                mask="1111 1111 1111 1111"
                                name="number"
                                type="text"
                                onChange={this.onChange}
                                //value={`${this.state.item.number}`}
                                className="form-control"
                                autoComplete="off"
                                maxLength="20"
                            ></MaskedInput>
                            {this.state.errors.number ? (
                                <div className="invalid-feedback">
                                    {this.state.errors.number}
                                </div>
                            ) : null}
                        </div>
                        <div className="form-group m-form__group row">
                            <div className="col-12 col-md-4">
                                <div className="form-group">
                                    <label>Expired month</label>
                                    <MaskedInput
                                        mask="11"
                                        placeholder="MM"
                                        name="expiration_month"
                                        onChange={this.onChange}
                                        value={this.state.item.expiration_month}
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        maxLength="5"
                                    ></MaskedInput>
                                    {this.state.errors.expiration_month ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.expiration_month}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form-group">
                                    <label>Expired year</label>
                                    <MaskedInput
                                        mask="1111"
                                        placeholder="YYYY"
                                        name="expiration_year"
                                        onChange={this.onChange}
                                        value={this.state.item.expiration_year}
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        maxLength="5"
                                    ></MaskedInput>
                                    {this.state.errors.expiration_year ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.expiration_year}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            
                            <div className="col-12 col-md-4">
                                <div className="form-group">
                                    <label>CVC</label>
                                    <MaskedInput
                                        mask="111"
                                        name="cvc"
                                        placeholder="123"
                                        type="text"
                                        onChange={this.onChange}
                                        value={this.state.item.cvc}
                                        className="form-control"
                                        autoComplete="off"
                                        maxLength="3"
                                    ></MaskedInput>
                                    {this.state.errors.cvc ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.cvc}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="model-actions">                       
                        <button
                            type="button"
                            onClick={this.props.hideUpdate}
                            className="btn btn-default"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.update}
                            disabled={this.state.loading}
                        >
                            {this.state.loading == true ? "Processing..." : "Update Card"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
EditModel.contextType = AppContext;
export default EditModel;



// WEBPACK FOOTER //
// ./src/components/writer/billing/EditModel.js